<template>
  <div>
    <section
      class="top-header py-3"
      :class="{ 'top-header-second': theme == 2 }"
    >
      <div
        class="container d-flex justify-content-between align-items-baseline"
      >
        <div class="align-items-baseline">
          <!--          <button type="button" id="all-categories" class="all-categories resp-menu-btn bg-none rounded py-1 px-2 d-lg-none"  @click="allCategoriesClose()" >-->
          <!--            <svg width="38px" height="38px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
          <!--              <rect fill="#fff" width="24" height="24" transform="rotate(180 12 12)" opacity="0"/>-->
          <!--              <circle fill="#fff" cx="4" cy="12" r=".75"/>-->
          <!--              <rect fill="#fff"  x="7" y="11" width="14" height="1.4" rx=".94" ry=".94"/>-->
          <!--              <rect fill="#fff" x="3" y="16" width="18" height="1.4" rx=".94" ry=".94"/>-->
          <!--              <rect fill="#fff" x="3" y="6" width="18" height="1.4" rx=".94" ry=".94"/></svg>-->
          <!--          </button>-->
          <button
            @click="addPath()"
            type="button"
            id="all-categories"
            class="
              all-categories
              resp-menu-btn
              bg-none
              rounded
              py-1
              px-2
              d-lg-none
            "
            data-toggle="modal"
            data-target="#RespModalMenu"
          >
            <svg
              width="38px"
              height="38px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                fill="#fff"
                width="24"
                height="24"
                transform="rotate(180 12 12)"
                opacity="0"
              />
              <circle fill="#fff" cx="4" cy="12" r=".75" />
              <rect
                fill="#fff"
                x="7"
                y="11"
                width="14"
                height="1.4"
                rx=".94"
                ry=".94"
              />
              <rect
                fill="#fff"
                x="3"
                y="16"
                width="18"
                height="1.4"
                rx=".94"
                ry=".94"
              />
              <rect
                fill="#fff"
                x="3"
                y="6"
                width="18"
                height="1.4"
                rx=".94"
                ry=".94"
              />
            </svg>
          </button>

          <router-link to="/" class="logo-img d-inline-block">
            <img
              src="@/assets/images/logo/logo-y.png"
              class="w-100 h-100"
              alt="نونان"
            />
          </router-link>

          <Nav></Nav>
        </div>
        <div class="header-buttons">
          <button
            type="button"
            class="bg-none ml-2"
            @click="showCloseSearchBox()"
          >
            <svg
              width="27"
              height="27"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11.7666"
                cy="11.7666"
                r="8.98856"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.0183 18.4851L21.5423 22"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button
            v-if="!isLogin"
            type="button"
            class="bg-none ml-2"
            data-toggle="modal"
            data-target="#loginModal"
          >
            <svg
              width="27"
              height="27"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11.5789"
                cy="7.27803"
                r="4.77803"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.00002 18.7014C3.99873 18.3655 4.07385 18.0337 4.2197 17.7311C4.67736 16.8158 5.96798 16.3307 7.03892 16.111C7.81128 15.9462 8.59431 15.836 9.38217 15.7815C10.8408 15.6533 12.3079 15.6533 13.7666 15.7815C14.5544 15.8367 15.3374 15.9468 16.1099 16.111C17.1808 16.3307 18.4714 16.77 18.9291 17.7311C19.2224 18.3479 19.2224 19.064 18.9291 19.6808C18.4714 20.6419 17.1808 21.0812 16.1099 21.2918C15.3384 21.4634 14.5551 21.5766 13.7666 21.6304C12.5794 21.7311 11.3866 21.7494 10.1968 21.6854C9.92221 21.6854 9.65677 21.6854 9.38217 21.6304C8.59663 21.5773 7.81632 21.4641 7.04807 21.2918C5.96798 21.0812 4.68652 20.6419 4.2197 19.6808C4.0746 19.3747 3.99955 19.0401 4.00002 18.7014Z"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <CartButton />

          <button
            v-if="isLogin"
            @click.prevent="showOptions = !showOptions"
            class="
              logged-in-btn
              d-inline-block
              bg-none
              border-radius7
              ml-2
              pl-2
            "
          >
            <div class="d-sm-inline-block d-none py-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="bi bi-person"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#ffc00f"
                  d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                />
              </svg>
            </div>
            <span
              class="fontsize13 d-sm-inline-block d-none text-color-theme mx-1"
            >
              <span
                v-if="FullName != null"
                class="fontsize-small text-color-theme mx-1"
              >
                {{ FullName }}</span
              >
              <span v-else class="fontsize13 text-color-theme mx-1"
                >حساب کاربری</span
              >
            </span>
            <span class="d-sm-none d-inline-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                fill="currentColor"
                class="bi bi-person mt-n1"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#ffc00f"
                  d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                />
              </svg>
            </span>
            <svg
              width="13"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.869 16.6308C10.811 16.5743 10.563 16.3609 10.359 16.1622C9.076 14.9971 6.976 11.9576 6.335 10.3668C6.232 10.1252 6.014 9.51437 6 9.18802C6 8.8753 6.072 8.5772 6.218 8.29274C6.422 7.93814 6.743 7.65368 7.122 7.49781C7.385 7.39747 8.172 7.2416 8.186 7.2416C9.047 7.08573 10.446 7 11.992 7C13.465 7 14.807 7.08573 15.681 7.21335C15.695 7.22796 16.673 7.38383 17.008 7.55431C17.62 7.86702 18 8.47784 18 9.13151V9.18802C17.985 9.61374 17.605 10.509 17.591 10.509C16.949 12.0141 14.952 14.9834 13.625 16.1768C13.625 16.1768 13.284 16.5129 13.071 16.659C12.765 16.887 12.386 17 12.007 17C11.584 17 11.19 16.8724 10.869 16.6308Z"
                fill="#ffc00f"
              />
            </svg>
            <transition name="fade">
              <div v-if="showOptions" id="loginUserOptions">
                <router-link
                  to="/user-panel"
                  @click="gotoUserPanel()"
                  :class="{ disabledLogout: disabledlLogout }"
                  >مشاهده حساب کاربری</router-link
                >
                <button
                  @click="signout()"
                  :class="{ disabledLogout: disabledlLogout }"
                >
                  خروج
                  <svg
                    class="top-slider-more-svg2 mr-2 mt-1"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.25 12.2743L19.25 12.2743"
                      stroke="#fff"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.2998 18.2987L4.2498 12.2747L10.2998 6.24969"
                      stroke="#fff"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </transition>
          </button>
        </div>
      </div>
    </section>
    <MainSearch></MainSearch>
    <!-- resp login Modal -->
    <RespLoginModal></RespLoginModal>
    <CartLists></CartLists>
    <RespModalMenu></RespModalMenu>
  </div>
</template>
<script>
import { cartListsOpen } from "@/libraries/functions";
import Nav from "./Nav";
import MainSearch from "./MainSearch";
import CartLists from "./CartLists";
import RespLoginModal from "./RespLoginModal";
import RespModalMenu from "./RespModalMenu";

import CartButton from "@/parts/Front/components/cart/CartButton";
export default {
  name: "TopHeader",
  data() {
    return {
      showOptions: false,
      disabledlLogout: false,
    };
  },
  components: {
    Nav,
    MainSearch,
    CartLists,
    RespLoginModal,
    RespModalMenu,
    CartButton,
  },
  props: {
    theme: {
      default: 2,
      type: [String, Number],
    },
  },
  methods: {
  
    checkBackButton() {
      if (!this.$route.fullPath.includes("#menu")) {
        $("#RespModalMenu").modal("hide");
      }
    },
    addPath() {
      if (!this.$route.fullPath.includes("#menu")) {
        this.$router.push(this.$route.fullPath + "#menu");
      }
    },
    gotoUserPanel() {
      this.showOptions = false;
    },
    signout() {
      window
        .swal({
          title: "آیا میخواهید خارج شوید؟",

          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله خارج شو"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.disabledlLogout = true;
            this.$axios.post("/customer/logout").then((res) => {
              console.log("okokokko");
              this.disabledlLogout = false;
              this.showOptions = false;
              // پاک کردن اطلاعات مربوط به کاربر از کوکی و ویو ایکس
              this.$root.deleteCookie("Authorization");
              delete this.$axios.defaults.headers.common["Authorization"];
              this.$store.commit("front/setLoginStatus", false);
            });
          }
        });
    },
    cartListsOpen,
    showCloseSearchBox() {
      const searchBox = document.querySelectorAll(".main-search")[0];
      let mainSearchResp = document.querySelectorAll(
        ".main-search-close-resp"
      )[0];
      searchBox.classList.toggle("show-main-search");
      if (mainSearchResp.style.display == "block") {
        mainSearchResp.style.display = "none";
      } else {
        mainSearchResp.style.display = "block";
        document.getElementById("searchInput").focus();
      }
    },

    // cartListsOpen() {
    //   let cartLists = document.getElementsByClassName("cart-lists")[0];
    //   const cartListsCloseResp = document.getElementsByClassName(
    //     "cart-lists-close-resp"
    //   )[0];
    //   // let cartFixed=document.getElementsByClassName('cart-fixed')[0];
    //   // cartFixed.style.left="-150px"
    //   cartListsCloseResp.style.display = "block";
    //   cartLists.style.left = "0";
    // },
    allCategoriesClose() {
      document
        .getElementById("all-categories")
        .classList.toggle("all-categories-close");
      let hasClassClose = document
        .getElementById("all-categories")
        .classList.contains("all-categories-close");
      let catSide = document.getElementsByClassName("all-categories-side")[0];
      let allCategoriesResp = document.querySelectorAll(
        ".all-categories-resp"
      )[0];

      // let wrapper = document.getElementsByClassName('wrapper')[0];
      if (hasClassClose) {
        catSide.style.right = "0px";
        allCategoriesResp.style.display = "block";
        // if(window.screen.width >= 1200){
        // wrapper.style.paddingRight="250px";
        // }
      } else {
        // if(window.screen.width >= 1200){
        //     wrapper.style.paddingRight="0";
        // }
        catSide.style.right = "-420px";
        allCategoriesResp.style.display = "none";
      }
    },
  },
  computed: {
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    FullName() {
      return this.$store.getters["front/getFullName"];
    },
  },
  mounted() {
    if (this.$route.fullPath.includes("#menu")) {
      // this.$router.replace(this.$route.fullPath.replace("#cart-modal", ""));
      document.getElementById("all-categories").click();
    }
    window.removeEventListener("popstate", this.checkBackButton);
    window.addEventListener("popstate", this.checkBackButton);
  },
};
// import Nav from "@/parts/Front/components/Nav";
// import LoginUser from '@/parts/Front/components/LoginUser'
// import AtlasLogo from '@/parts/Front/components/AtlasLogo'
// import { cartListsOpen } from "@/libraries/functions";
// import findUrl from "@/libraries/links/LinkResolver";
// import CartButton from "@/parts/Front/components/cart/CartButton"
// import HeaderNotification from "@/parts/Front/components/notification/HeaderNotification";
// export default {
//   name: "TopHeader",
//   inject:['mediaQueries'],
//   components:{
//     HeaderNotification,
//     CartButton,AtlasLogo,LoginUser,Nav
//   },
//   data() {
//     return {
//       showOptions: false,
//     };
//   },
//   methods: {
//     findUrl,
//     // cartListsCloseBody(){
//     //   const cartLists=document.getElementsByClassName('cart-lists')[0];
//     //   const cartListsCloseResp = document.getElementsByClassName('cart-lists-close-resp')[0];
//     //   cartListsCloseResp.style.display="none";
//     //   cartLists.style.left="-390px";
//     // },
//     cartListsOpen,
//     allCategoriesClose() {
//       document
//         .getElementById("all-categories")
//         .classList.toggle("all-categories-close");
//       let hasClassClose = document
//         .getElementById("all-categories")
//         .classList.contains("all-categories-close");
//       let catSide = document.getElementsByClassName("all-categories-side")[0];
//       let allCategoriesResp = document.querySelectorAll(
//         ".all-categories-resp"
//       )[0];

//       // let wrapper = document.getElementsByClassName('wrapper')[0];
//       if (hasClassClose) {
//         catSide.style.right = "0px";
//         allCategoriesResp.style.display = "block";
//         // if(window.screen.width >= 1200){
//         // wrapper.style.paddingRight="250px";
//         // }
//       } else {
//         // if(window.screen.width >= 1200){
//         //     wrapper.style.paddingRight="0";
//         // }
//         catSide.style.right = "-420px";
//         allCategoriesResp.style.display = "none";
//       }
//     },
//     showCloseSearchBox() {
//       const searchBox = document.querySelectorAll(".main-search")[0];
//       let mainSearchResp = document.querySelectorAll(
//         ".main-search-close-resp"
//       )[0];
//       searchBox.classList.toggle("show-main-search");
//       if (mainSearchResp.style.display == "block") {
//         mainSearchResp.style.display = "none";
//       } else {
//         mainSearchResp.style.display = "block";
//       }
//     },
//   },
//   mounted() {

//   },
//   computed: {
//     menu() {
//       if (this.$store.getters["front/getHomeData"] != null) {
//         return this.$store.getters["front/getHomeData"].menu.header;
//       } else {
//         return this.$store.getters["front/getHomeData"];
//       }
//     },
//     status() {
//       return this.$store.getters["front/getHomeDataStatus"];
//     },
//     isLogin() {
//       return this.$store.getters["front/getLoginStatus"];
//     },
//     notifications() {
//       return this.$store.getters["front/getNotifications"];
//     }
//   },
// };
</script>

<style scoped>
@media only screen and (min-width:991px) {
    .header-buttons {
        display: flex;
        justify-content: space-evenly;
        width: 23%;
    }
}

@media screen and (max-width: 300px) {
  .header-buttons svg {
    width: 20px;
    height: 20px;
  }
  .logo-img {
    width: 35px;
  }
  .all-categories svg {
    width: 30px !important;
    height: 30px !important;
  }
}

#loginUserOptions {
  display: flex;
  flex-direction: column;
  position: absolute;
}
#loginUserOptions button,
#loginUserOptions a {
  padding: 10px;
  background-color: #190704c9;
  color: white;
  transition: all 1s;
  border-radius: 5px;
}
#loginUserOptions button:hover,
#loginUserOptions a:hover {
  background-color: #361009;
  color: #ffbd02 !important;
}

@media (max-width: 768px) {
  #loginUserOptions {
    left: 0;
  }
}
/* افزودن استایل به کدهای اضافه شده */
/* .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.childMenu {
  color: #666;
}
#menuSkelton {
  display: flex;
  justify-content: space-around;
  width: 300px;
}
#menuSkelton div {
  width: 50px;
  height: 30px;
} */
</style>
